import React from 'react';
import Main from './pages/Main';

const App: React.FC = () => {
  return <Main />;
};

export default App;
